import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Cliente } from '../models/clientes';


const BACKEND_URL = environment.apiUrl + '/clientes/';

@Injectable({
    providedIn: 'root'
})
export class ClientesService {

    constructor(private http: HttpClient) { }

    /**
     * Obtiene la lista de clientes y regresa un obserbable del tipo clientes.  
     * @param cantidadPorPagina la cantidad de registros que desea el usuario obtener. 
     * @param paginaActual la pagina actua de registros.
     */
    obtenerClientes(clientesPorPagina: number, paginaActual: number): Observable<any> {
        const queryParams = `?page=${paginaActual}&limit=${clientesPorPagina}`;

        return this.http.get(BACKEND_URL + queryParams);
    }

    /**
     * Obtiene la lista de clientes y regresa un obserbable del tipo clientes.  
     * @param cantidadPorPagina la cantidad de registros que desea el usuario obtener. 
     * @param paginaActual la pagina actua de registros.
     */
    obtenerClientesBusqueda(valorBusqueda: any): Observable<any> {
        const url = BACKEND_URL + 'busqueda/' + valorBusqueda;
        const params = new HttpParams().append('valorBusqueda', valorBusqueda);

        return this.http.get(url, { params: params });
    }

    /**
     * Este metodo obtiene el cliente que se desea buscar, recibiendo como parametro su id,
     * Retorna el cliente buscado.
     * @param id del ramo que deseas obtener
     */
    obtenerCliente(id: string): Observable<Cliente> {
        return this.http.get<Cliente>(BACKEND_URL + id);
    }

    /**
     * Este metodo elimina el cliente que se desea eliminar, recibiendo como parametro su id,
     * Retorna el cliente elminiado.
     * @param id del ramo que deseas eliminar
     */
    eliminarCliente(id: string): Observable<any> {
        return this.http.delete<Cliente>(BACKEND_URL + id);
    }

    /**
     * Este metodo realiza la actualizacion de un cliente en especifico, retora un observable del ramo actualizado.
     * @param cliente que se pretende actualizar.
     */
    actualizarCliente(cliente: Cliente): Observable<Cliente> {
        return this.http.put<Cliente>(BACKEND_URL + cliente.cl_num, cliente);
    }

    /**
     * Este metodo se utiliza para guardar el cliente en base de datos, se ejecuta desde effects.
     * @param cliente que se requiere guardar en base de datos
     */
    crearCliente(cliente: Cliente): Observable<any> {
        return this.http.post<Cliente>(BACKEND_URL, cliente);
    }

    /**
     * Evalua si la clave del cliente ya existe en el catalogo de ramos.
     * @param claveCliente clave a ser evaluada.
     */
    validarExistenciaClienteRfc(rfcCliente: string): Observable<any> {
        return this.http.get(BACKEND_URL + 'validarrfc/' + rfcCliente);
    }

    validarClienteNombre(nombreCliente: string): Observable<any> {
        return this.http.get(BACKEND_URL + 'validarnom/' + nombreCliente);
    }

    validarClienteGrupo(grupo: string): Observable<any> {
        return this.http.get(BACKEND_URL + 'validargpo/' + grupo);
    }

    obtenerPoblacion(): Observable<any> {
        return this.http.get(BACKEND_URL + 'obtener-poblacion/');
    }

    obtenerPoblacionPorTipo(tipo:string): Observable<any> {
        const queryParams = `?tipo=${tipo}`; 
        return this.http.get(BACKEND_URL + 'obtener-poblacion-tipo'+queryParams);
    }


    obtenerClientePorNombre(val: string): Observable<any> {
        const url = BACKEND_URL + 'busquedanombrenumero';
        const params = new HttpParams().append('valorBusqueda', val);

        return this.http.get(url, { params: params });
    }
}
